<template>
  <div>
    <page-list
      :list="list"
      :columns="columns" />
      <div class="text-right">{{ $t('scope.text_835', [`${data.amount}${data.currency === 'CNY' ? $t('scope.text_468') : $t('scope.text_469') }`, data.currency]) }}</div>
  </div>
</template>

<script>
import * as R from 'ramda'
import {
  getNameDescriptionTableColumn,
  getTimeTableColumn,
  getCopyWithContentTableColumn,
} from '@/utils/common/tableColumn'
import { getNameFilter } from '@/utils/common/tableFilter'
import { numerify } from '@/filters'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'OrderList',
  mixins: [WindowsMixin, ListMixin],
  props: {
    resId: String,
    data: {
      type: Object,
      required: true,
    },
    getParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'billing_orders',
        getParams: this.getParam,
        filterOptions: {
          title: getNameFilter({ label: this.$t('scope.text_439'), field: 'title' }),
          sku: {
            label: 'SKU',
          },
          description: {
            label: this.$t('table.column.title.desc'),
            filter: true,
            formatter: val => {
              return `description.contains("${val}")`
            },
          },
        },
      }),
      columns: [
        getCopyWithContentTableColumn({
          field: 'sku',
          title: 'SKU',
        }),
        getNameDescriptionTableColumn({
          field: 'title',
          title: this.$t('scope.text_439'),
          edit: false,
          editDesc: false,
          hideField: true,
          slotCallback: row => {
            return (
              <span>{ row.title }</span>
            )
          },
        }),
        {
          field: 'rate',
          title: this.$t('scope.text_836'),
          minWidth: 70,
          sortable: true,
          formatter: ({ cellValue }) => {
            return numerify(cellValue, '0,0.00')
          },
        },
        {
          field: 'unit',
          title: this.$t('scope.text_837'),
          minWidth: 80,
        },
        {
          field: 'quantity',
          title: this.$t('scope.text_838'),
          minWidth: 70,
          sortable: true,
        },
        {
          field: 'origin_cost',
          title: this.$t('scope.text_839'),
          minWidth: 80,
          sortable: true,
          formatter: ({ cellValue }) => {
            return numerify(cellValue, '0,0.00')
          },
        },
        {
          field: 'subtotal',
          title: this.$t('scope.text_840'),
          minWidth: 80,
          sortable: true,
          formatter: ({ cellValue }) => {
            return numerify(cellValue, '0,0.00')
          },
        },
        getTimeTableColumn({ title: this.$t('scope.text_834'), field: 'placed_at', sortable: true }),
      ],
    }
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    getParam () {
      const ret = {
        ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams),
      }
      if (!ret.project_domain) {
        ret.bill_id = this.resId.toString()
      } else {
        delete ret.scope
      }
      return ret
    },
  },
}
</script>
